import { FlexRow, GenericComponent } from '@gorila-shared-ui/components';
import { useStyles } from '../../../hooks/useStyles';

export function StyledCardHeaderWrapper({ children, classNames = '' }: GenericComponent) {
  const { css, concatenateClasses, theme } = useStyles();

  const baseStyles = css({
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${theme.sizing.scale500} ${theme.sizing.scale600}`,
  });

  return <FlexRow classNames={concatenateClasses(baseStyles, classNames)}>{children}</FlexRow>;
}
